'use client'

import { getValue } from '@/lib/utils'
import { useProductDetailSafe } from '../../context/product-detail-context'
import {
  getSetdoPart,
  useProductDetailStore,
} from '../../hooks/use-product-detail-store'
import { ProductInfoVariantItem } from '../product-info/product-info-variant-item'
import { InstructionSize } from './instructions-size'
import { ProductInfoSizeItem } from './product-info-size-item'

export const ProductInfoSizesCombo: React.FC = () => {
  const { comboSelectedInfo, product } = useProductDetailSafe()
  const {
    isDisableComboSize,
    handleComboSizeChange,
    setIsSizeGuideDrawerOpen,
  } = useProductDetailStore()

  const combo = product?.combo?.options || []

  return (
    <>
      {combo?.map((item, optionIndex) => (
        <div key={item.title}>
          <div className='mb-2 flex items-baseline justify-between lg:py-0'>
            <span className='font-sans text-base leading-5 text-neutral-900'>
              {item.title}:
              <p className='ml-2 inline font-medium text-neutral-600'>
                {getValue(comboSelectedInfo, `option${optionIndex + 1}`, '')}
              </p>
            </span>
            {item?.option_id?.includes('size') &&
              getSetdoPart(product, optionIndex)?.product_id && (
                <InstructionSize
                  productId={getSetdoPart(product, optionIndex)?.product_id}
                  product={product}
                  setIsSizeGuideDrawerOpen={setIsSizeGuideDrawerOpen}
                />
              )}
          </div>
          {item?.option_id?.includes('color') ? (
            <ul className='grid grid-cols-5 gap-2.5 gap-y-1.5 md:flex md:flex-wrap lg:gap-3 lg:gap-y-3'>
              {item.values.map((value) => {
                const isActive =
                  getValue(
                    comboSelectedInfo,
                    `option${optionIndex + 1}`,
                    ''
                  ) === value.value
                return (
                  <li className='col-span-1' key={value.value}>
                    <ProductInfoVariantItem
                      isActive={isActive}
                      onClick={() =>
                        handleComboSizeChange(value.value, optionIndex)
                      }
                      title={value.label}
                      imageUrl={value.image || ''}
                    />
                  </li>
                )
              })}
            </ul>
          ) : (
            <ul className='flex flex-wrap gap-2 gap-y-3'>
              {item.values.map((val) => (
                <ProductInfoSizeItem
                  key={val.value}
                  isActive={
                    getValue(
                      comboSelectedInfo,
                      `option${optionIndex + 1}`,
                      ''
                    ) === val.value
                  }
                  onClick={() => handleComboSizeChange(val.value, optionIndex)}
                  title={val.label}
                  isDisabled={isDisableComboSize(val.value, optionIndex)}
                />
              ))}
            </ul>
          )}
        </div>
      ))}
    </>
  )
}
